import React, { Component } from 'react'
import './checkbox.scss'

class Checkbox extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isChecked: Boolean(props.isChecked) || '',
			type: props.type ? props.type : 'checkbox',
			id: props.id ? props.id : '',
			name: props.name ? props.name : '',
			imgSrc: props.imgSrc ? props.imgSrc : '',
			for: props.for ? props.for : '',
			label: props.label ? props.label : '',
			state: props.state ? props.state : '',
			value: props.value ? props.value : '',
			labelClasses: props.labelClasses ? props.labelClasses : '',
			classes: props.classes ? props.classes : ''
		}
	}

	componentDidUpdate(prevProps) {
		if (typeof this.props.isChecked !== 'undefined' && this.props.isChecked !== prevProps.isChecked) {
			this.setState({ isChecked: this.props.isChecked })
		}
	}

	handleChange = () => {
		const isChecked = !this.state.isChecked
		if (typeof this.props.isChecked === 'undefined') {
			this.setState({ isChecked })
		}
		typeof this.props.onChange === 'function' && this.props.onChange(isChecked)
	}

	render() {
		const classes = ['input', this.state.classes, this.state.state].join(' ')
		const labelClass = ['group vbui--checkbox', this.props.labelClasses, this.state.showIcon].join(' ')
		return (
			<div className={labelClass}>
				<input
					onChange={this.handleChange}
					checked={this.state.isChecked}
					id={this.state.id}
					name={this.state.name}
					disabled={this.props.disabled}
					className={classes}
					type={this.state.type}
					data-key={this.props['data-key']}
					data-value={this.props['data-value']}
				/>
				<label htmlFor={this.state.id} onClick={this.props.click}>
					{this.state.imgSrc && <img alt="" src={this.state.imgSrc} />}
					{this.state.label}
					{this.props.children}
					{this.props.downloadImg && <img className="download-img" alt="" src={this.props.downloadImg} />}
				</label>
				{this.props.labelClasses === 'switch' && <span className="switch-label">{this.state.label}</span>}
			</div>
		)
	}
}

export default Checkbox
